// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { Global, css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { zindex, sizes } from "../../helpers/theme";

let backgroundStyles = props => css`
  background-color: ${props.bg};
  z-index: ${zindex.background};
  position: fixed;
  top: 0;
  right: 0;
  bottom: -20vh;
  left: 0;
`;
let BackgroundStyled = styled("div")`
  ${backgroundStyles}
`;

/*
let backgroundImageStyles = (props) => css`
  background-image: url(${props.image});
  mix-blend-mode: overlay;
  background-size: cover;
  background-position: 50% 50%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
`
let BackgroundImageStyled = styled('div')`${backgroundImageStyles}`
*/

let layer1 = props => css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${props.bg1};
`;
let layer2 = props => css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${props.bg2};
`;
let layer3 = props => css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${props.bg3};
`;

export class Background extends React.Component {
  render() {
    return (
      <BackgroundStyled id="Bg">
        <Global
          styles={css`
            .BgColor1,
            .BgColor2,
            .BgColor3,
            .BgColor4,
            .BgColor5,
            .BgColor6 {
              transition: all ${sizes.timer * 4}ms;
            }
          `}
        />
        <svg
          version="1.1"
          css={layer1}
          id="Layer_1"
          x="0px"
          y="0px"
          height="100%"
          width="100%"
          style={{ enableBackground: "new 0 0 100 100" }}
        >
          <linearGradient
            id="backgroundsvg"
            gradientUnits="userSpaceOnUse"
            x1="0%"
            y1="100%"
            x2="100%"
            y2="0%"
          >
            <stop className="BgColor1" offset="0" />
            <stop className="BgColor2" offset="100%" />
            {/*
            <animate attributeName="x1" dur="60s" values="0%;100%;100%;0%;0%" repeatCount="indefinite" />
            <animate attributeName="y1" dur="60s" values="100%;100%;0%;0%;100%" repeatCount="indefinite" />
            <animate attributeName="x2" dur="60s" values="100%;0%;0%;100%;100%" repeatCount="indefinite" />
            <animate attributeName="y2" dur="60s" values="0%;0%;100%;100%;0%" repeatCount="indefinite" />
            */}
          </linearGradient>
          <rect
            width="100%"
            height="100%"
            style={{ fill: "url(#backgroundsvg)" }}
          />
        </svg>
        <svg
          version="1.1"
          css={layer2}
          id="Layer_2"
          x="0px"
          y="0px"
          height="100%"
          width="100%"
          style={{ enableBackground: "new 0 0 100 100" }}
        >
          <linearGradient
            id="backgroundsvg2"
            gradientUnits="userSpaceOnUse"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop className="BgColor3" offset="0" />
            <stop className="BgColor4" stopOpacity="0" offset="1" />
            {/*
            <animate attributeName="x1" dur="20s" values="0%;100%;100%;0%;0%" repeatCount="indefinite" />
            <animate attributeName="y1" dur="20s" values="0%;0%;100%;100%;0%" repeatCount="indefinite" />
            <animate attributeName="x2" dur="20s" values="100%;0%;0%;100%;100%" repeatCount="indefinite" />
            <animate attributeName="y2" dur="20s" values="100%;100%;0%;0%;100%" repeatCount="indefinite" />
            */}
          </linearGradient>
          <rect
            width="100%"
            height="100%"
            style={{ fill: "url(#backgroundsvg2)" }}
          />
        </svg>
        <svg
          version="1.1"
          css={layer3}
          id="Layer_3"
          x="0px"
          y="0px"
          height="100%"
          width="100%"
          style={{ enableBackground: "new 0 0 100 100" }}
        >
          <linearGradient
            id="backgroundsvg3"
            gradientUnits="userSpaceOnUse"
            x1="0%"
            y1="100%"
            x2="100%"
            y2="0%"
          >
            <stop className="BgColor5" offset="0" />
            <stop className="BgColor6" stopOpacity="0" offset="1" />
            <animate
              attributeName="x1"
              dur="20s"
              values="0%;100%;100%;0%;0%"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y1"
              dur="20s"
              values="100%;100%;0%;0%;100%"
              repeatCount="indefinite"
            />
            <animate
              attributeName="x2"
              dur="20s"
              values="100%;0%;0%;100%;100%"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y2"
              dur="20s"
              values="0%;0%;100%;100%;0%"
              repeatCount="indefinite"
            />
          </linearGradient>
          <rect
            width="100%"
            height="100%"
            style={{ fill: "url(#backgroundsvg3)" }}
          />
        </svg>
      </BackgroundStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Background.js